export const STORAGE_RECENTLY_LOGIN_SNS_KEY = 'recent_login_sns'

// 코치마크 닫힘 여부 — 계정별(userId 목록)로 저장. 서버 전송 없는 localStorage 사용.
// 닉네임 코치마크(헤더 1번 + 프로필 2번 공용)
export const STORAGE_COACH_NICKNAME_DISMISSED_KEY = 'hml_coach_nickname_dismissed'
// 성도 인증 코치마크(프로필 3번)
export const STORAGE_COACH_SAINT_DISMISSED_KEY = 'hml_coach_saint_dismissed'
